/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import { Table, Spin } from "antd";
import queryString from "query-string";
import React, { useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { LoadingOutlined } from '@ant-design/icons';
import { fetchOrdersData } from "../../redux/orders/ordersActions";
import orderTableColumnData from "./orderTableColumnData";
import loader from '../../assets/images/loader.svg';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const OrdersTable = () => {
  const loading = <img src={loader} alt={loader} className="h-16 w-16" />;

  // Accessing the product data State Store
  const ordersData = useSelector((state) => [
    state.orders.ordersData,
    state.orders.ordersTotalPages,
    state.orders.ordersSummary,
    state.orders.selectedRowKeys,
    state.orders.listLoading
  ]);

  // Accessing the product dispatch Method
  const dispatch = useDispatch();

  // Get Current URL Path
  const { search } = useLocation();
  const { path } = useRouteMatch();
  const history = useHistory();

  const isQueryParamExist = (data) => {
    const newURL = queryString.stringifyUrl({
      url: path + search,
      query: { page: data.selected + 1 },
    });
    history.push(newURL);
  };
  // Fetching data during Initialization & if the search parameter changes
  useEffect(() => {
    dispatch(fetchOrdersData(search));
  }, [dispatch, search]);
  

  return (
    <>
    <Spin indicator={loading} spinning={ordersData[4]}>
      <Table
        rowSelection={() => {}}
        rowKey={(record) => record.id}
        dataSource={ordersData[0]}
        columns={orderTableColumnData}
        pagination={false}
        size="medium"
      />
      <ReactPaginate
        previousLabel="<"
        nextLabel=">"
        breakLabel="..."
        breakClassName="break-me"
        pageCount={ordersData[1]}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={isQueryParamExist}
        containerClassName="dokan-pagination-container"
        subContainerClassName="dokan-pagination-li"
        activeClassName="dokan-pagination-active"
      />
    </Spin>  
    </>
  );
};

export default OrdersTable;
